import React from "react";
import { Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import { Search, XCircle } from "react-bootstrap-icons";

function LandAcquisitionFilters({
    filterStatus,
    filterMemberType,
    searchQuery,
    setSearchQuery,
    handleFilterChange,
    handleMemberTypeChange,
    handleSearch,
    resetFilters
}) {
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
        }
    };

    return (
        <>
            <h5 className="mb-3">Filter Land Acquisition Requests</h5>
            <Row>
                <Col lg={3} md={6} className="mb-3 mb-md-0">
                    <Form.Group>
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                            as="select"
                            value={filterStatus}
                            onChange={(e) => handleFilterChange(e.target.value)}
                        >
                            <option value="">All Statuses</option>
                            <option value="pending">Pending</option>
                            <option value="approved">Approved</option>
                            <option value="rejected">Rejected</option>
                            <option value="completed">Completed</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col lg={3} md={6} className="mb-3 mb-md-0">
                    <Form.Group>
                        <Form.Label>Member Type</Form.Label>
                        <Form.Control
                            as="select"
                            value={filterMemberType}
                            onChange={(e) => handleMemberTypeChange(e.target.value)}
                        >
                            <option value="">All Types</option>
                            <option value="member">Members</option>
                            <option value="non-member">Non-Members</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col lg={4} md={6} className="mb-3 mb-md-0">
                    <Form.Group>
                        <Form.Label>Search by ID or Name</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type="text"
                                placeholder="Enter ID or name..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                            <InputGroup.Append>
                                <Button variant="primary" onClick={handleSearch}>
                                    <Search size={16} />
                                </Button>
                            </InputGroup.Append>
                        </InputGroup>
                    </Form.Group>
                </Col>
                <Col lg={2} className="d-flex align-items-end">
                    <Button
                        variant="outline-secondary"
                        className="mt-md-0 w-100"
                        onClick={resetFilters}
                    >
                        <XCircle size={16} className="mr-2" />
                        Reset
                    </Button>
                </Col>
            </Row>
        </>
    );
}

export default LandAcquisitionFilters;